import { createTheme } from '@mui/material/styles';

// REDERI 통합 관리 플랫폼 테마 — dark(기본) / light 지원.
const DARK = {
  mode: 'dark',
  primary: { main: '#7c9eff' },
  secondary: { main: '#a5e0c9' },
  background: { default: '#0e1217', paper: '#161b22' },
  text: { primary: '#e6edf3', secondary: '#8b949e' },
  divider: '#30363d',
  success: { main: '#3fb950' },
  warning: { main: '#d29922' },
  info: { main: '#58a6ff' },
  error: { main: '#f85149' },
};

const LIGHT = {
  mode: 'light',
  primary: { main: '#4a6fe0' },
  secondary: { main: '#2f9e78' },
  background: { default: '#f6f8fa', paper: '#ffffff' },
  text: { primary: '#1f2328', secondary: '#636c76' },
  divider: '#d0d7de',
  success: { main: '#1a7f37' },
  warning: { main: '#9a6700' },
  info: { main: '#0969da' },
  error: { main: '#cf222e' },
};

export function makeTheme(mode) {
  return createTheme({
    palette: mode === 'light' ? LIGHT : DARK,
    typography: {
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
      fontSize: 14,
      h1: { fontSize: '2rem', fontWeight: 700 },
      h2: { fontSize: '1.5rem', fontWeight: 600 },
      h3: { fontSize: '1.25rem', fontWeight: 600 },
      h4: { fontSize: '1.1rem', fontWeight: 600 },
      monospace: { fontFamily: 'JetBrains Mono, monospace' },
    },
    shape: { borderRadius: 8 },
    components: {
      MuiButton: { styleOverrides: { root: { textTransform: 'none', fontWeight: 500 } } },
      MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    },
  });
}

// 하위호환 (기존 import { theme } 사용처 대비) — 기본 다크.
export const theme = makeTheme('dark');
